import React from 'react';
import { motion } from 'framer-motion';
import './FeatureComparison.css';

const FeatureComparison = () => {
  const features = [
    { name: 'NSE Data Feed', without: '15-min delayed', with: 'Live (0 delay)' },
    { name: 'Order Flow Analysis', without: '✗', with: '✓' },
    { name: 'Market Profile Charts', without: '✗', with: '✓' },
    { name: 'Institutional Tracking', without: '✗', with: '✓' },
    { name: 'COT Volume', without: '✗', with: '✓' },
    { name: 'Footprint Charts', without: '✗', with: '✓' },
    { name: 'IB/IS Signals', without: '✗', with: '✓' },
    { name: 'Gamma Density Analysis', without: '✗', with: '✓' }
  ];

  return (
    <section className="feature-compare-section">
      <div className="container">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          ⚖️ Without Elite vs With Elite
        </motion.h2>
        
        <div className="comparison-table">
          <motion.div
            className="comparison-row comparison-header"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="feature-name">Feature</div>
            <div className="check-no">Without Elite</div>
            <div className="check-yes">With Elite</div>
          </motion.div>

          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="comparison-row"
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.05 }}
            >
              <div className="feature-name">{feature.name}</div>
              <div className="check-no">{feature.without}</div>
              <div className="check-yes">{feature.with}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureComparison;

